/** Keep hosted URLs intact, including signatures. Filename-only legacy media needs migration. */
export function resolveMediaUrl(path: string | null | undefined): string {
  if (typeof path !== "string") return "";
  const value = path.trim();
  if (!/^https?:\/\//i.test(value)) return "";
  try {
    const url = new URL(value);
    return url.username || url.password ? "" : value;
  } catch { return ""; }
}
export function resolveFirstMediaUrl(paths: string | string[] | null | undefined): string {
  const list = Array.isArray(paths) ? paths : [paths];
  return list.map(resolveMediaUrl).find(Boolean) || "";
}
